<div class="padding-20" *ngIf="show.form" id="planningCouponForm">

  <div class="infoContainer">
    <span>{{ 'campaign.date_validity' | translate }}<b>{{campaignInfo.name}}</b>: <b>{{ 'campaign.from' | translate }}
      {{ campaignInfo.dateStart | date :'dd/MM/yyyy' }} {{ 'campaign.to' | translate }} {{ campaignInfo.dateEnd | date
      : dateFormat }}</b></span>
  </div>
  <br />
  <br />
  <div class="ui-g">

    <div class="ui-g-4">
      <br />
      <br />
      <div class="title">
      <span>{{ 'campaign.message_period' | translate }}</span>

        <span class="asterix">*</span>&nbsp; <i class="fa fa-info-circle icon"
          pTooltip="E' l'intervallo di tempo in cui i tuoi coupon saranno distribuiti"></i>
      </div>
      <br />
      <br />
      <button class="dateButton" (click)="onChangeAsCampaign()">{{ 'campaign.set_emission_date' | translate }} </button>
      <!--    <app-form-fields #switchAsCampaign data-testid="switchAsCampaign" [readOnly]="readOnly" [fieldSchema]="formSchema.form.come_campagna" (fieldModelChange)="onChangeAsCampaign($event)" [(fieldModel)]="switch.asCampaign"></app-form-fields> -->
      <br />
      <br />
      <app-form-fields #data_inizio_emissione data-testid="data_inizio_emissione" [showRequiredAsterix]="false"
      [(fieldModel)]="fieldModel.data_inizio_emissione" [type]="'date'"
      [placeholder]="'campaign.select_start_date_emission' | translate" [readOnly]="readOnly"
      [fieldSchema]="formSchema.form.data_inizio_emissione"></app-form-fields>
    
      <br />
      <app-form-fields #data_fine_emissione data-testid="data_fine_emissione" [showRequiredAsterix]="false"
      [(fieldModel)]="fieldModel.data_fine_emissione" [type]="'date'" [readOnly]="readOnly"
      [fieldSchema]="formSchema.form.data_fine_emissione"
      [placeholder]="'campaign.select_end_date_emission' | translate"></app-form-fields>

    </div>
    <div class="ui-g-2"></div>
    <br />
    <br />
    <div class="errorDate" *ngIf="show.errorDate==true">
      <span *ngIf="language == 'it'">{{errorDateText}}</span>
      <span *ngIf="language == 'en'">Check the errors and data ranges!</span>
    </div>

  </div>
  <br />

</div>


// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-planning/message-3-planning.component.html